import type { SelectOption } from '../Select/SelectOption/SelectOption';
import { baseOptionComparator } from './baseOptionComparator';

export function baseQuery(
  query: string,
  options: SelectOption[]
): SelectOption[] {
  return options.filter((option) => baseOptionComparator(option, query));
}
